import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import "./i18n";
import { clearStaleServiceWorker } from "./utils/clearStaleServiceWorker";
import { logBuildVersion, BUILD_ID } from "./utils/buildVersion";

// Clean up stale PWA service workers from previous deployments
clearStaleServiceWorker();

// Log build version for debugging stale deploy issues
logBuildVersion();

/**
 * 🛡️ SELF-HEALING: Version Synchronization
 * Checks if the loaded JS bundle is stale compared to the server.
 * Uses the build timestamp baked into the JS bundle vs the one on the server.
 */
let hasReloaded = false;
async function checkVersion() {
  if (hasReloaded) return;
  try {
    const response = await fetch(`/version.json?_=${Date.now()}`, {
      cache: 'no-store',
      headers: { 'Pragma': 'no-cache' },
    });
    if (!response.ok) return;
    const data = await response.json();
    
    if (data.version && data.version !== BUILD_ID && BUILD_ID !== 'dev') {
      console.log('[🛡️ Chawni] New version detected. Current:', BUILD_ID, 'Server:', data.version);
      
      const reloadKey = `reloaded_${data.version}`;
      if (sessionStorage.getItem(reloadKey)) {
        console.warn('[🛡️ Chawni] Already reloaded for this version, preventing loop.');
        return;
      }
      
      sessionStorage.setItem(reloadKey, 'true');
      hasReloaded = true;
      // Clear caches and reload
      if ('caches' in window) {
        const names = await caches.keys();
        for (const name of names) await caches.delete(name);
      }
      window.location.reload();
    }
  } catch (e) {
    // Non-critical
  }
}

// Check on boot and every 2 minutes
checkVersion();
setInterval(checkVersion, 1000 * 60 * 2);

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
